module.exports = __webpack_public_path__ + "assets/img/G1.e2334fc6.png";